import { render, staticRenderFns } from "./AxTempStaffReturnDialog.vue?vue&type=template&id=e87ed7de&scoped=true"
import script from "./AxTempStaffReturnDialog.vue?vue&type=script&lang=ts"
export * from "./AxTempStaffReturnDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxTempStaffReturnDialog.vue?vue&type=style&index=0&id=e87ed7de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87ed7de",
  null
  
)

export default component.exports